import { CheckCircle2, Phone, Mail } from "lucide-react";
import { CONTACT, QUOTE_CHECKLIST } from "../../data";
import { SectionEyebrow } from "./Reveal";
import { InquiryForm } from "./InquiryForm";

export const QuoteSection = () => (
  <section id="quote" className="relative bg-oyf-black py-20 md:py-28" data-testid="quote">
    <div className="container-oyf grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-6">
        <SectionEyebrow dark>Before Requesting a Quote</SectionEyebrow>
        <h2 className="font-display font-extrabold text-white tracking-tight text-3xl md:text-4xl leading-[1.05]">What We Need to Quote Your Shipment</h2>
        <ul className="mt-7 space-y-3">
          {QUOTE_CHECKLIST.map((c) => (
            <li key={c} className="flex gap-3 text-white/75 text-sm"><CheckCircle2 size={18} className="text-oyf-yellow shrink-0 mt-0.5" />{c}</li>
          ))}
        </ul>
        <div className="mt-7 bg-oyf-yellow/10 border border-oyf-yellow/40 rounded-lg p-4">
          <p className="text-sm text-white/85 leading-relaxed">Accurate dimensions and weight help us identify whether the shipment is suitable for a cargo van or Sprinter van.</p>
        </div>
        <div className="mt-7 space-y-3">
          <a href={CONTACT.tel} className="flex items-center gap-3 text-white hover:text-oyf-yellow transition-colors font-semibold"><Phone size={18} /> Urgent request? Call {CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white hover:text-oyf-yellow transition-colors font-semibold"><Mail size={18} /> {CONTACT.email}</a>
        </div>
      </div>

      <div className="lg:col-span-6">
        <div className="bg-white rounded-2xl p-6 md:p-9">
          <SectionEyebrow>Request a Freight Quote</SectionEyebrow>
          <h3 className="font-display font-extrabold text-oyf-black text-2xl md:text-3xl">Tell Us What Needs to Move</h3>
          <div className="mt-6">
            <InquiryForm source="Freight Quote Section" />
          </div>
        </div>
      </div>
    </div>
  </section>
);
